// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"91":"7878ac58","128":"df31507d","753":"125c8b46","787":"df31507d","896":"df31507d"}[chunkId] + ".chunk.css";
};